import { render, staticRenderFns } from "./UnblockUserDialog.vue?vue&type=template&id=42878f2c&"
import script from "./UnblockUserDialog.vue?vue&type=script&lang=js&"
export * from "./UnblockUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./UnblockUserDialog.vue?vue&type=style&index=0&id=42878f2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports